/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Progress_Extra_Totals_VolumeInputs */

const en_us2_progress_extra_totals_volume = /** @type {(inputs: Progress_Extra_Totals_VolumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volume this month`)
};

const pt_br2_progress_extra_totals_volume = /** @type {(inputs: Progress_Extra_Totals_VolumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volume no mês`)
};

const es_419_progress_extra_totals_volume = /** @type {(inputs: Progress_Extra_Totals_VolumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volumen del mes`)
};

const pt_pt2_progress_extra_totals_volume = /** @type {(inputs: Progress_Extra_Totals_VolumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volume no mês`)
};

const fr_fr2_progress_extra_totals_volume = /** @type {(inputs: Progress_Extra_Totals_VolumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volume ce mois-ci`)
};

const de_de2_progress_extra_totals_volume = /** @type {(inputs: Progress_Extra_Totals_VolumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volumen diesen Monat`)
};

const it_it2_progress_extra_totals_volume = /** @type {(inputs: Progress_Extra_Totals_VolumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volume nel mese`)
};

/**
* | output |
* | --- |
* | "Volume this month" |
*
* @param {Progress_Extra_Totals_VolumeInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_extra_totals_volume = /** @type {((inputs?: Progress_Extra_Totals_VolumeInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_Extra_Totals_VolumeInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_extra_totals_volume(inputs)
	if (locale === "es-419") return es_419_progress_extra_totals_volume(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_extra_totals_volume(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_extra_totals_volume(inputs)
	if (locale === "de-DE") return de_de2_progress_extra_totals_volume(inputs)
	if (locale === "it-IT") return it_it2_progress_extra_totals_volume(inputs)
	return en_us2_progress_extra_totals_volume(inputs)
});
export { progress_extra_totals_volume as "progress-extra.totals_volume" }